import { useTranslations } from 'next-intl';
import getOption from '../utils/getOption';

export default function Sorting({
  onChange,
  sorting,
  defaultSorting = true,
}: {
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  sorting: string;
  defaultSorting?: boolean;
}) {
  const t = useTranslations('sorting');
  const sorts = [
    {
      value: '',
      label: t('button.label'),
    },
    {
      value: '-scope_price',
      label: t('price.descending'),
    },
    {
      value: 'scope_price',
      label: t('price.ascending'),
    },
    {
      value: '-published',
      label: t('published.descending'),
    },
    {
      value: 'published',
      label: t('published.ascending'),
    },
  ];
  if (getOption('HAS_AUCTIONS')) {
    sorts.push({
        value: '-time',
        label: t('time.descending'),
      },
      {
        value: 'time',
        label: t('time.ascending'),
      },
    )
  }

  return (
    <select
      className='h-full font-semibold uppercase cursor-pointer rounded-sm border border-brand bg-black px-4 py-1 text-white lg:min-w-[13.5rem]'
      onChange={onChange}
      value={defaultSorting ? t('button.label') : sorting}
    >
      {sorts.map((el) => {
        return (
          <option
            key={el.value}
            value={el.value}
            className={`${sorting === el.value ? 'font-bold text-brand' : ''}`}
          >
            {el.label}
          </option>
        );
      })}
    </select>
  );
}
